// helpers.js
export function formattedDate(datetime, notShowWeekDay = false) {
  // Create a new Date object from the original string
  const date = new Date(datetime)

  // Define an array of weekday names
  const weekdayNames = ['អាទិត្យ', 'ចន្ទ', 'អង្គារ', 'ពុធ', 'ព្រ.ហ', 'សុក្រ', 'សៅរ៍']

  // Get the day, month, and year from the Date object
  const day = date.getDate()
  const month = date.getMonth()
  const year = date.getFullYear()

  // Check if the day is available
  let formattedDateString = ''
  if (datetime.length > 7) {
    // Get the weekday name from the array using the getDay() method
    const weekdayName = weekdayNames[date.getDay()]

    // Construct the formatted date string including day, month, and year
    if (notShowWeekDay) {
      formattedDateString = `${day} ${getMonthName(month)} ${year}`
    } else {
      formattedDateString = `${weekdayName} ${day} ${getMonthName(month)} ${year}`
    }
  } else {
    // Construct the formatted date string only with month and year
    formattedDateString = `${getMonthName(month)} ${year}`
  }

  return formattedDateString
}
function getMonthName(monthIndex) {
  // Define an array of month names
  const monthNames = ['មករា', 'កុម្ភៈ', 'មីនា', 'មេសា', 'ឧសភា', 'មិថុនា', 'កក្កដា', 'សីហា', 'កញ្ញា', 'តុលា', 'វិច្ឆិការ', 'ធ្នូ']

  // Get the month name from the array using the monthIndex
  return monthNames[monthIndex]
}

export function formatNumber(number) {
  // Convert number to locale string with commas for thousands separators
  // and fixed two decimal places
  return Number(number).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function formatTwoDigits(num) {
  return num.toFixed(2)
}

export function isDateLaterThanToday(date) {
  const today = new Date()
  const the_date = new Date(date)
  // Set hours, minutes, seconds, and milliseconds to 0 to compare only the dates
  today.setHours(0, 0, 0, 0)

  the_date.setHours(0, 0, 0, 0)
  return the_date < today
}

export function lateDays(date) {
  const due = new Date(date);
  const today = new Date();
  const diffTime = today - due;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  return diffDays > 0 ? diffDays : 0;
}
